<template>
    <div>
        <!-- <a href @click.prevent="setReloading(true)">Turn on</a>
        <a href @click.prevent="setReloading(false)">Turn off</a> -->
        <a href @click.prevent="toggleReload"> <i class="fad fa-sync mr-2" :class="reloading ? 'fa-spin' : ''"></i>auto reload: {{ reloading ? "on" : "off" }} </a>
    </div>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import { Inertia } from "@inertiajs/inertia";

export default {
    mixins: [Helpers],
    data() {
        return {
            reloading: false
        };
    },
    methods: {
        reload() {
            if (this.reloading) {
                setTimeout(() => {
                    Inertia.reload({ preserveState: true, preserveScroll: true });
                    this.reload();
                }, 30000);
            }
        },

        toggleReload() {
            this.reloading = !this.reloading;

            if (this.reloading) {
                this.reload();
            }
        },

        setReloading(on) {
            this.reloading = on;

            if (this.reloading) {
                this.reload();
            }
        }
    },
    created() {
        this.$eventHub.$on("set-reloading", this.setReloading);
    },
    beforeDestroy() {
        this.$eventHub.$off("set-reloading");
    }
};
</script>
